import { ProductDiscountType } from '../../types/Products/productDiscount';
import { request } from '../../utils/request';

export const addDiscountToProduct = (
  id: number,
  updates: ProductDiscountType,
  authToken: string
) =>
  request({
    method: 'POST',
    url: `/products/${id}/discount`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    callback: undefined,
    formData: updates,
    onError: (err) => {
      throw err;
    },
  });
